import { useFormContext } from 'react-hook-form';
import { z } from 'zod';

export const SingleQuestionChangeSchema = z.object({
  questionId: z.string(),
});

export type SingleQuestionChangeFormInput = z.infer<typeof SingleQuestionChangeSchema>;

export const useSingleQuestionChangeForm = useFormContext<SingleQuestionChangeFormInput>;
